import Parse from "parse";

// =================================================================
// !!! CRITICAL: UPDATE THESE WITH YOUR BACK4APP KEYS !!!
// This code prioritizes environment variables (for local/Vercel)
// and falls back to hardcoded placeholders (for Canvas execution).
// =================================================================

// 1. Prioritize reading from environment variables
const APP_ID = process.env.REACT_APP_PARSE_APP_ID;
const JAVASCRIPT_KEY = process.env.REACT_APP_PARSE_JAVASCRIPT_KEY;
const SERVER_URL = process.env.REACT_APP_PARSE_SERVER_URL;
// If your Back4App server is located in Europe, change the fallback URL to 'https://api.eu.back4app.com/'

// Initialize the Parse SDK
if (
  APP_ID.includes("YOUR_BACK4APP_") ||
  JAVASCRIPT_KEY.includes("YOUR_BACK4APP_")
) {
  console.warn(
    "Parse client not fully initialized: API keys are still placeholders. Update them for functionality."
  );
}
Parse.initialize(APP_ID, JAVASCRIPT_KEY);
Parse.serverURL = SERVER_URL;

/**
 * Calls the Cloud Code function 'sendContactEmail' to process the
 * configuration inquiry and send the email.
 * * The function name must match the Cloud Code function: 'sendContactEmail'.
 * * @param {object} formData - The structured data object from the ContactForm.
 * @returns {Promise<{success: boolean, messageId?: string, error?: string}>}
 */
export async function sendConfigurationEmail(formData) {
  // Use a minimal retry logic for robustness against transient network issues.
  const MAX_RETRIES = 2;
  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      // Calling the function we successfully tested in the API Console
      const result = await Parse.Cloud.run("sendContactEmail", formData);

      return { success: true, messageId: result.id };
    } catch (error) {
      console.error(
        `Attempt ${
          attempt + 1
        }: Error calling Cloud Function 'sendContactEmail':`,
        error.message
      );

      if (error.code === 142) {
        // Code 142 is typically reserved for custom errors thrown within the Cloud Function (e.g., validation failed).
        return { success: false, error: error.message };
      }

      // Retry only on network or transient errors
      if (attempt < MAX_RETRIES - 1) {
        // Wait 1s (for attempt 0), then 2s (for attempt 1)
        await new Promise((resolve) =>
          setTimeout(resolve, 1000 * (attempt + 1))
        );
      } else {
        // Last attempt failed
        return {
          success: false,
          error: `Server error: ${
            error.message ||
            "Could not connect to service after multiple attempts."
          }`,
        };
      }
    }
  }
}
